import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Rule bodies are prose Markdown — "## Good" / "## Bad" sections with fenced
 * code. Rendered with an explicit component map because there is no typography
 * plugin in this build.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="space-y-2 text-sm leading-relaxed">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h3 className="mt-4 text-sm font-bold tracking-tight first:mt-0" {...p} />,
          h2: (p) => <h3 className="mt-4 text-sm font-bold tracking-tight first:mt-0" {...p} />,
          h3: (p) => <h4 className="mt-3 text-sm font-semibold first:mt-0" {...p} />,
          p: (p) => <p className="[&:not(:first-child)]:mt-2" {...p} />,
          ul: (p) => <ul className="mt-2 list-outside list-disc space-y-1 pl-5" {...p} />,
          ol: (p) => <ol className="mt-2 list-outside list-decimal space-y-1 pl-5" {...p} />,
          a: (p) => <a className="underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
          blockquote: (p) => (
            <blockquote className="mt-2 border-l-2 border-border pl-3 text-muted-foreground" {...p} />
          ),
          pre: (p) => (
            <pre
              className="mt-2 overflow-x-auto rounded-sm border border-border bg-muted/60 p-3 font-mono text-xs"
              {...p}
            />
          ),
          code: ({ className, ...p }) =>
            className?.startsWith("language-") ? (
              <code className={className} {...p} />
            ) : (
              <code className="rounded-sm bg-muted px-1 py-0.5 font-mono text-xs" {...p} />
            ),
          table: (p) => (
            <div className="mt-2 overflow-x-auto">
              <table className="w-full border-collapse text-xs" {...p} />
            </div>
          ),
          th: (p) => <th className="border border-border px-2 py-1 text-left font-semibold" {...p} />,
          td: (p) => <td className="border border-border px-2 py-1 align-top" {...p} />,
          hr: (p) => <hr className="my-3 border-border" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
